import legUniversal from './leg-universal.locale'

export default {
  protection:{
    currentMaritalStatus: "Statut marital actuel",
    simulationMaritalStatus: "Statut marital simulé",
    maritalStatusToSimulate: "Simuler ce statut marital",
    matrimonialRegimeCardTitle: "Régimes matrimoniaux",
    matrimonialRegimeCardSubtitle: "Simulez un changement de régime matrimonial",
    matrimonialRegimeSectionTitle: "Choisir un régime matrimonial",
    matrimonialRegimeCommunitySectionTitle: "Sélectionner des biens qui appartiendraient à la communauté",
    maritalClauseCardTitle: "Clause Maritale",
    maritalClauseCardSubtitle: "Simuler l'adoption d'une clause maritale",
    maritalClauseSectionTitle: "Choisir une clause maritale",
    maritalClauseCommunitySectionTitle: "Sélectionner les biens entrant dans la clause de préciput",
    maritalClauseShareSectionTitle: "Définir la répartition des biens communs à la liquidation de la communauté",
    maritalClauseInegalAttributionWarningContentLabel: "Lorsque 100% des biens de la communauté sont attribués au conjoint survivant, cela équivaut à une clause d’attribution intégrale.",
    maritalClauseInegalAttributionLabel: "Part attribuée au conjoint survivant",
    maritalClauseEstateAssetsLabel: "Part intégrée dans la masse successorale",
    ddvCardTitle: "Donation au dernier vivant",
    ddvCardSubtitle: "Simulez la mise en place d'une donation au dernier vivant",
    ddvSectionTitle: "Mettre en place une donation au dernier vivant",
    ddvTypesSectionTitle: "Choisir une quotité",
    ddvOption: "Oui",
    noDdvOption: "Non",
    matrimonialRegimes: {
      separation_of_property: {
        label: "Séparation de biens",
      },
      community_of_furniture_and_acquests: {
        label: "Communauté de meubles et d'acquêts",
      },
      separation_with_acquests_company: {
        label: "Séparation de biens avec société d'acquêts",
      },
      reduced_community_of_acquests: {
        label: "Communauté réduite aux acquêts",
      },
      universal: {
        label: "Communauté universelle",
      },
      foreign: {
        label: "Régime de droit étranger",
      },
      full_universal: {
        label: "Communauté universelle intégrale",
      },
      legal_regime_start_date_after_01_02_1966: {
        label: "Régime légal à compter du 01/02/1966",
      },
      legal_regime_start_date_before_01_02_1966: {
        label: "Régime légal avant le 01/02/1966",
      },
      optional_participation_of_acquests: {
        label: "Régime optionnel de participation aux acquêts",
      },
      participation_to_acquests: {
        label: "Participation aux acquêts",
      },
    },
    maritalClauses: {
      none: {
        label: "Aucun",
      },
      clause_of_preciput: {
        label: "Clause de préciput",
      },
      inegal_attribution: {
        label: "Partage Inégal",
      },
      integral_attribution: {
        label: "Attribution intégrale",
      },
    },
    ddv: {
      totality_in_usufruct: {
        label: "Totalité en usufruit",
      },
      three_fourths_usufruct_and_one_fourth_full_ownership: {
        label: "¾ en usufruit, ¼ en pleine propriété",
      },
      available_portion_in_full_ownership: {
        label: "Quotité disponible en pleine propriété",
      },
      hundred_percent_in_full_ownership: {
        label: "100% en pleine propriété",
      },
    }
  },
  levers: {
    legUniversal
  }
}
